import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  SCHEDULE_RESUME_SCHEDULE_BEGIN,
  SCHEDULE_RESUME_SCHEDULE_SUCCESS,
  SCHEDULE_RESUME_SCHEDULE_FAILURE,
  SCHEDULE_RESUME_SCHEDULE_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function resumeSchedule(args = {}) {
  return (dispatch) => {
    dispatch({
      type: SCHEDULE_RESUME_SCHEDULE_BEGIN,
    });

    const { projectId, taskId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/schedules/${taskId}/resume`;
      const doRequest = axios.post(url, {}, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: SCHEDULE_RESUME_SCHEDULE_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: SCHEDULE_RESUME_SCHEDULE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Resume Failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissResumeScheduleError() {
  return {
    type: SCHEDULE_RESUME_SCHEDULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_RESUME_SCHEDULE_BEGIN:
      return {
        ...state,
        resumeSchedulePending: true,
        resumeScheduleError: null,
      };

    case SCHEDULE_RESUME_SCHEDULE_SUCCESS:
      return {
        ...state,
        resumeSchedulePending: false,
        resumeScheduleError: null,
      };

    case SCHEDULE_RESUME_SCHEDULE_FAILURE:
      return {
        ...state,
        resumeSchedulePending: false,
        resumeScheduleError: action.data.error,
      };

    case SCHEDULE_RESUME_SCHEDULE_DISMISS_ERROR:
      return {
        ...state,
        resumeScheduleError: null,
      };

    default:
      return state;
  }
}
